// Playful decorative SVGs: wave section dividers + floating doodles

export function WaveTop({ color = "#FFFDF7", className = "" }) {
  return (
    <div className={`w-full overflow-hidden leading-[0] ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-[40px] md:h-[70px]">
        <path fill={color} d="M0,40 C240,90 480,0 720,30 C960,60 1200,10 1440,45 L1440,80 L0,80 Z" />
      </svg>
    </div>
  );
}

export function WaveBottom({ color = "#FFFDF7", className = "" }) {
  return (
    <div className={`w-full overflow-hidden leading-[0] ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-[40px] md:h-[70px]">
        <path fill={color} d="M0,40 C240,-10 480,80 720,50 C960,20 1200,70 1440,35 L1440,0 L0,0 Z" />
      </svg>
    </div>
  );
}

export function Squiggle({ className = "", color = "#FFB703" }) {
  return (
    <svg className={className} width="80" height="24" viewBox="0 0 80 24" fill="none" aria-hidden="true">
      <path d="M2 12 C10 2, 18 22, 26 12 S42 2, 50 12 S66 22, 78 12" stroke={color} strokeWidth="4" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export function StarDoodle({ className = "", color = "#FFB703" }) {
  return (
    <svg className={className} width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <path d="M20 2 L24 14 L37 14 L26 22 L30 35 L20 27 L10 35 L14 22 L3 14 L16 14 Z" fill={color} />
    </svg>
  );
}

export function BlobDoodle({ className = "", color = "#4CC9F0" }) {
  return (
    <svg className={className} width="120" height="120" viewBox="0 0 120 120" fill="none" aria-hidden="true">
      <path d="M60 8 C86 8 112 26 112 58 C112 88 90 112 58 112 C30 112 8 90 8 60 C8 30 30 8 60 8 Z" fill={color} opacity="0.18" />
    </svg>
  );
}

export function DotsDoodle({ className = "", color = "#FF70A6" }) {
  return (
    <svg className={className} width="70" height="40" viewBox="0 0 70 40" fill="none" aria-hidden="true">
      {[0, 1, 2, 3].map((r) =>
        [0, 1, 2].map((c) => (
          <circle key={`${r}-${c}`} cx={6 + r * 18} cy={6 + c * 14} r="3" fill={color} opacity="0.7" />
        )),
      )}
    </svg>
  );
}
